<template>
  <div>
    <navigation />
    <div class="tasklist-container">
      <div class="tasklist">
        <router-link to="/addtask" style="text-decoration: unset;">
          <button class="create-task">+ 新建任务</button>
        </router-link>
        <tasklist :task-list="taskList" :page-size="pageSize" :page-index="pageIndex" :item-total="itemTotal" />
        <pagination
          :page-size="pageSize"
          :page-index="pageIndex"
          :item-total="itemTotal"
          @changeindex="changePageIndex"
          @changesize="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tasklist from '@/components/tasklist';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import * as api from '@/api/api.js';

export default {
  name: 'task',
  data() {
    return {
      taskList: [],
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
    };
  },
  components: {
    tasklist,
    pagination,
    navigation,
  },
  mounted: function() {
    this.getTaskList();
  },
  methods: {
    getTaskList() {
      api
        .getTaskList({ page: this.pageIndex, pagesize: this.pageSize })
        .then(res => {
          this.taskList = res.data.tasks;
          this.itemTotal = res.data.taskCount;
        })
        .catch(() => {});
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getTaskList();
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.pageIndex = 0;
      this.getTaskList();
    },
  },
};
</script>

<style type="text/css" scoped>
.create-task {
  display: inline-block;
  margin: 24px 0px;
  height: 38px;
  width: 102px;
  font-size: 14px;
}
</style>
